import { ReportSectionName } from '../common/types/reports';

/**
 * Map of report sections to their description.
 * (Because API doesn't contain any section data)
 */
export const RecordSectionDescriptions: Record<ReportSectionName, string | null> = {
  [ReportSectionName.CoverPage]:
    'An introduction to the report detailing who the report is for, who the report was prepared by and the date.',
  [ReportSectionName.ExecSummary]:
    'Sets out the details of the findings and recommendations in simple, everyday language.',
  [ReportSectionName.Disclosure]:
    'Important information about you and your duties as a financial services provider.',
  [ReportSectionName.Fna]: null,
  [ReportSectionName.Quote]: 'Include an existing quote for this client.',
  [ReportSectionName.SLA]:
    'An agreement to obtain all necessary information and present a written proposal that details the recommended business needs and solutions at a specified cost.',
  [ReportSectionName.RecordOfAdvice]:
    'A record of the information and material on which the advice was based, the financial products which were considered, and the financial product or products recommended with an explanation of why the product or products selected, is or are likely to satisfy the client’s identified needs and objectives.',
  [ReportSectionName.Agreement]: 'Detailed agreements of each identified need.',
};

/**
 * List of report sections that are preselected by default and cannot be deselected.
 */
export const preselectedReportSections = new Set([
  ReportSectionName.CoverPage,
  ReportSectionName.ExecSummary,
]);
